import * as React from 'react';

/** Returns a ref and booleans indicating whether the element has content clipped to the left and/or right. */
export function useScrollOverflow<T extends HTMLElement>() {
	const ref = React.useRef<T>(null);
	const [canScrollLeft, setCanScrollLeft] = React.useState(false);
	const [canScrollRight, setCanScrollRight] = React.useState(false);

	React.useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const check = () => {
			setCanScrollLeft(el.scrollLeft > 1);
			setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
		};
		check();
		el.addEventListener('scroll', check);
		const observer = new ResizeObserver(check);
		observer.observe(el);
		return () => {
			el.removeEventListener('scroll', check);
			observer.disconnect();
		};
	}, []);

	return { ref, canScrollLeft, canScrollRight };
}
